module.exports = __webpack_public_path__ + "svg/logo-invest-in-holland.svg";